import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appModalPortal]',
  standalone: true
})
export class ModalPortalDirective {
  constructor(readonly viewContainerRef: ViewContainerRef) {}
}
